import { Chip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

const parsePayloadTimestamp = (payload) => {
    if (!payload) return null;
    if (typeof payload === "object") return payload.postedAt ?? null;
    if (typeof payload !== "string") return null;
    try {
        const parsed = JSON.parse(payload);
        return parsed?.postedAt ?? null;
    } catch {
        return null;
    }
};

const formatTimestamp = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    const pad = (part) => String(part).padStart(2, "0");
    const hours = date.getUTCHours();
    const hours12 = hours % 12 || 12;
    const ampm = hours >= 12 ? "PM" : "AM";
    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}, ${pad(hours12)}:${pad(date.getUTCMinutes())} ${ampm}`;
};

export const SapIbpTableHeaders = () => {
    return [
        {
            headerName: "",
            checkboxSelection: true,
            headerCheckboxSelection: true,
            width: 44,
            minWidth: 44,
            maxWidth: 44,
            pinned: "left",
            suppressMenu: true,
            sortable: false,
            filter: false,
            resizable: false,
        },
        {
            field: "timestamp",
            headerName: "Timestamp",
            minWidth: 200,
            valueGetter: (params) => {
                const directTimestamp = params?.data?.timestamp;
                const payloadTimestamp = parsePayloadTimestamp(params?.data?.payload);
                return formatTimestamp(directTimestamp ?? payloadTimestamp);
            },
        },
        {
            field: "plant",
            headerName: "Plant Code",
        },
        {
            field: "material",
            headerName: "TCCC Material Number",
        },
        {
            field: "supplier",
            headerName: "Supplier ID",
        },
        {
            field: "action",
            headerName: "Status",
            cellRenderer: (params) => {
                const value = (params?.value ?? "").toString();
                const normalized = value.trim().toLowerCase();
                const wrap = (node) => (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        {node}
                    </div>
                );
                if (normalized === "success") {
                    return wrap(
                        <Chip
                            icon={<CheckIcon sx={{ fontSize: 16 }} />}
                            label="Success"
                            size="small"
                            color="success"
                            sx={{ fontWeight: 600 }}
                        />
                    );
                }
                if (normalized === "failure") {
                    return wrap(
                        <Chip
                            icon={<CloseIcon sx={{ fontSize: 16, color: "inherit" }} />}
                            label="Failure"
                            size="small"
                            sx={{
                                backgroundColor: "#ef4444",
                                color: "white",
                                fontWeight: 600,
                                "& .MuiChip-icon": { color: "white" },
                            }}
                        />
                    );
                }
                return wrap(<span>{value || "-"}</span>);
            },
        },
        {
            field: "retries",
            headerName: "Retries",
            cellRenderer: (params) => params?.data?.retries ?? params?.data?.retires ?? "-",
        },
        {
            field: "message",
            headerName: "Message",
            minWidth:250,
            cellRenderer: (params) => {
                const value = params?.value ?? "";
                return (
                    <span
                        title={value}
                        style={{
                            display: "block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {value}
                    </span>
                );
            },
        },
    ];
};